import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["level"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from './Text';
import { HEADING_TYPES } from '../../constants/HEADING_TYPES';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledHeading = /*#__PURE__*/styled(Text).withConfig({
  shouldForwardProp: doNotForwardTransientProp(['fontFamily'])
}).withConfig({
  displayName: "StyledHeading",
  componentId: "c11n-8-64-0__sc-ktujwe-0"
})([""]);
/**
 * An alias for heading types of the [`<Text>`](#/Typography%20components?id=text) component.
 *
 * @since 6.0.0
 */

var Heading = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var level = _ref.level,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledHeading, _extends({
    as: "h" + level,
    fontType: HEADING_TYPES[level],
    ref: ref
  }, props));
});
Heading.displayName = 'Heading';
Heading.propTypes = {
  /** A string or number representing the heading level */
  level: PropTypes.oneOf(['1', '2', '3', '4', '5', '6', 1, 2, 3, 4, 5, 6]).isRequired,

  /** Change the font family of the heading */
  fontFamily: PropTypes.oneOf(['serif', 'sansSerif']),

  /**
   * The styled-components
   * [polymorphic "as"](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any
};
Heading.defaultProps = {
  fontFamily: 'sansSerif'
};
export default Heading;